if (!customElements.get('payment-plan-selector')) {
  customElements.define('payment-plan-selector', class PaymentPlanSelector extends HTMLElement {
    connectedCallback() {
      this.sellingPlanInput = this.querySelector('[data-selling-plan-input]');
      this.section = this.closest('.shopify-section') || document.body;
      this.handlePlanChange = this.handlePlanChange.bind(this);
      this.handleSectionUpdate = this.handleSectionUpdate.bind(this);
      this.addEventListener('change', this.handlePlanChange);
      this.section.addEventListener('change', this.handleSectionUpdate);
      this.section.addEventListener('click', this.handleSectionUpdate);
      this.updateVisibility();
    }

    disconnectedCallback() {
      this.section.removeEventListener('change', this.handleSectionUpdate);
      this.section.removeEventListener('click', this.handleSectionUpdate);
    }

    handleSectionUpdate() {
      requestAnimationFrame(() => this.updateVisibility());
    }

    updateVisibility() {
      const picker = this.section.querySelector('product-variants');
      if (!picker) return;

      const selectedVariant = picker.querySelector('.js-product-variant input:checked');
      this.classList.toggle('is-disabled', !selectedVariant);
      this.querySelectorAll('[data-plan-option]').forEach((radio) => {
        radio.disabled = !selectedVariant;
      });

      if (!selectedVariant) this.resetToPayInFull();
    }

    resetToPayInFull() {
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = '';
        this.sellingPlanInput.disabled = true;
      }
      const payInFull = this.querySelector('[data-plan-option][value=""]');
      if (payInFull) payInFull.checked = true;
    }

    handlePlanChange(event) {
      const option = event.target.closest('[data-plan-option]');
      if (!option || !this.sellingPlanInput) return;

      if (option.value) {
        this.sellingPlanInput.value = option.value;
        this.sellingPlanInput.disabled = false;
      } else {
        this.sellingPlanInput.value = '';
        this.sellingPlanInput.disabled = true;
      }
    }
  });
}
